import type { CityConfig } from "../city-template/types";

export const kalispellConfig: CityConfig = {
  city: "Kalispell",
  state: "Montana",
  stateAbbr: "MT",
  slug: "kalispell",
  route: "/kalispell",
  title: "Emergency Passport Kalispell, MT — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Kalispell, MT — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Kalispell, Whitefish, Columbia Falls, and Flathead County travelers. No Denver trip needed.",
  h1: "Emergency & Expedited Passport Services in Kalispell, MT",
  heroSubtitle: "Glacier National Park trip to Canada side? FCA flight connecting to Seattle for international departure? Flathead Valley business travel to trade shows? We help Kalispell residents — from Whitefish families to Columbia Falls outdoor professionals to Bigfork retirees — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Breathtaking%20panoramic%20view%20of%20Kalispell%20Montana%20with%20the%20Flathead%20Valley%20and%20snowcapped%20Swan%20Mountains%20in%20the%20distance%20at%20golden%20hour%2C%20historic%20downtown%20main%20street%20with%20western%20storefronts%2C%20wildflower%20meadows%20in%20foreground%2C%20warm%20amber%20light%20over%20the%20valley%2C%20editorial%20travel%20photography%20style%20with%20crisp%20detail%20and%20natural%20colors%2C%20no%20people%20or%20vehicles%20visible&width=1800&height=700&seq=kalispell-hero-2026&orientation=landscape",
  heroImageAlt: "Kalispell Montana with Flathead Valley and Swan Mountains at golden hour",
  geoPosition: "48.2023;-114.3158",
  geoPlacename: "Kalispell, Montana",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle, WA 98101",
    distance: "Nearest regional passport agency — located approximately 490 miles from Kalispell via I-90; not practical for most Flathead Valley residents",
  },
  nearbyCitiesZips: [
    { name: "Kalispell", zips: "59901, 59903, 59904" },
    { name: "Whitefish", zips: "59937" },
    { name: "Columbia Falls", zips: "59912" },
    { name: "Bigfork", zips: "59911" },
    { name: "Lakeside", zips: "59922" },
    { name: "Polson", zips: "59860" },
    { name: "Libby", zips: "59923" },
    { name: "Eureka", zips: "59917" },
  ],
  benefits: [
    { icon: "ri-global-line", title: "Glacier Cross-Border Passport Expertise", desc: "Glacier National Park's Waterton-Glacier International Peace Park spans U.S.-Canada border. We help Flathead families and visitors get passports for cross-border park and outdoor access." },
    { icon: "ri-flight-takeoff-line", title: "FCA Glacier Park International Airport", desc: "Connecting flights to Seattle, Salt Lake City, Denver, Minneapolis, and Chicago O'Hare for international departures. We coordinate timelines around your FCA connection." },
    { icon: "ri-building-2-line", title: "No Denver Trip Needed", desc: "Denver Passport Agency is 760 miles away — completely impractical for Kalispell residents. Our registered courier service handles everything remotely." },
    { icon: "ri-home-2-line", title: "Flathead Valley Families + Seasonal Residents", desc: "Part-time Bigfork and Lakeside residents heading south for winter, families planning international cruise vacations — we help everyone with passport needs across Flathead County." },
  ],
  internalLinks: [
    { name: "Expedited passport in Missoula, MT", route: "/missoula" },
    { name: "Fast passport services in Bozeman, MT", route: "/bozeman" },
    { name: "Quick passport services in Billings, MT", route: "/billings" },
    { name: "Urgent passport services in Coeur d'Alene, ID", route: "/coeur-dalene" },
    { name: "Montana passport services overview", route: "/montana" },
  ],
  fpcOfficeAddress: "915 2nd Ave Suite 500, Seattle, WA 98101",
  fpcOfficeNote: "Fast Passport Center serves Kalispell via secure registered courier with direct access to the Denver Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 12+ hours to Colorado. Kalispell residents can ship from any UPS Store, FedEx Office, or post office location across the Flathead Valley.",
  fpcOfficeDistance: "Serving Kalispell, Whitefish, Columbia Falls, Bigfork, Lakeside, Polson, and all Flathead County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Kalispell and the Flathead Valley. From the historic downtown district to the Whitefish resort corridor, from Columbia Falls near Glacier's west entrance to the lakeside communities of Bigfork and Lakeside — we serve all of Flathead County. Our courier service eliminates the need to drive 760 miles to Denver for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Kalispell and all Flathead County communities including Whitefish, Columbia Falls, Bigfork, Lakeside, and Polson. We also serve seasonal residents who split time between Montana and warmer destinations, plus cross-border travelers accessing Waterton-Glacier International Peace Park.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Kalispell as simple as possible — with the efficiency Flathead Valley residents, Whitefish outdoor enthusiasts, and Glacier-bound travelers need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Kalispell travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Kalispell travelers encounter unique passport issues — from cross-border Glacier National Park access to FCA connection timing to seasonal residence documentation challenges. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Flathead Valley travelers — from Whitefish families to Kalispell business owners to Columbia Falls outdoor guides — trust us when their international departure is days away and Denver is simply not an option.",
  faqIntro: "Have questions about expedited passports in Kalispell, MT? Here are the most common ones we hear from Flathead Valley travelers.",
  statePageRoute: "/states/montana",
  statePageName: "Montana",
  servicesIntro: "Whether you need a renewal before a trip to Canada through Glacier, an emergency passport for a last-minute FCA connecting flight, or a first-time passport for a Flathead family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dojmt.gov/driving/",
  dmvLabel: "Montana Motor Vehicle Division — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Denver trip needed — we handle everything remotely", "Ideal for upcoming international travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with government shutdowns", "In-person clerk appointment required in Kalispell or Whitefish", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Denver agency is 760 miles from Kalispell", "Completely impractical for Flathead Valley residents"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "FCA flight connecting to international departure in 2 days? Glacier cross-border emergency? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Kalispell travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Kalispell residents renew fast — no agency visit required for most renewals. Perfect for Flathead families, Whitefish seasonal residents, and Columbia Falls professionals.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Flathead Valley residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed — so your Glacier trip to Canada or FCA connecting flight is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Flathead family trip or Whitefish ski vacation abroad stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations. Common for Flathead Valley residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Kalispell business owners, outdoor gear reps, and consultants who travel while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Flathead Valley travelers through the process so your international plans stay on schedule.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for Flathead Valley residents crossing into Alberta regularly.",
      bullets: ["Wallet-size convenience", "Land and sea crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Kalispell MT", description: "Urgent passport processing for Kalispell Montana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Kalispell MT", description: "Fast passport renewal for Kalispell Montana residents with a previously-issued passport." },
    { name: "First-Time Passport Kalispell MT", description: "New passport application services for Kalispell Montana residents applying for their first passport." },
    { name: "Child Passport Kalispell MT", description: "Minor passport services for Kalispell Montana families with children under 16." },
    { name: "Name Change Passport Kalispell MT", description: "Passport name correction after marriage, divorce, or legal name changes for Kalispell residents." },
    { name: "Second Passport Kalispell MT", description: "Second passport services for Kalispell frequent travelers and business professionals." },
  ],
  testimonials: [
    {
      name: "Sarah T.",
      location: "Whitefish",
      rating: 5,
      text: "Our family booked a trip to Banff and realized our kids' passports had expired. Fast Passport Center got them back in 5 days. Living in the Flathead Valley, driving to Denver was totally out of the question — this saved us.",
      service: "Child Passport Renewal",
    },
    {
      name: "Mike R.",
      location: "Kalispell",
      rating: 5,
      text: "I had a business conference in Vancouver and my passport was expired. They handled everything remotely — I shipped from the Kalispell UPS Store and my passport arrived in 4 days. Incredible service for Montana.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Johnson Family",
      location: "Bigfork",
      rating: 5,
      text: "We live in Bigfork half the year and needed passports for a cruise out of Seattle. They walked us through the entire process and got everything done in time. Will definitely use again.",
      service: "New Passport — Family",
    },
    {
      name: "Dan P.",
      location: "Columbia Falls",
      rating: 5,
      text: "Outdoor guide heading to New Zealand for the season — needed a passport renewal fast. They got it done without me leaving the Flathead. Can't recommend enough for anyone in northwest Montana.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "kalispell-1",
      name: "Kalispell Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "350 N Meridian Rd",
      city: "Kalispell",
      state: "MT",
      zip: "59901",
      phone: "(406) 755-6045",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Kalispell",
      website: "https://tools.usps.com/find-location.htm?location=1379474",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Flathead County. Passport photos available on-site. Appointment strongly recommended — book at least a week in advance during summer tourist season.",
      icon: "ri-mail-line",
    },
    {
      id: "kalispell-2",
      name: "Whitefish Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "424 Baker Ave",
      city: "Whitefish",
      state: "MT",
      zip: "59937",
      phone: "(406) 862-2144",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Whitefish — about 15 miles north of Kalispell",
      website: "https://tools.usps.com/find-location.htm?location=1388776",
      websiteLabel: "USPS Location",
      notes: "Convenient for Whitefish and Big Mountain resort area residents. Limited appointment availability during peak summer months — schedule early.",
      icon: "ri-mail-line",
    },
    {
      id: "kalispell-3",
      name: "Columbia Falls Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "265 1st Ave W",
      city: "Columbia Falls",
      state: "MT",
      zip: "59912",
      phone: "(406) 892-5845",
      hours: "Mon–Fri 9:00 AM – 3:00 PM (appointment required)",
      distance: "Columbia Falls — Glacier National Park west entrance",
      website: "https://tools.usps.com/find-location.htm?location=1368686",
      websiteLabel: "USPS Location",
      notes: "Nearest acceptance facility to Glacier National Park's west entrance. Limited hours — call to confirm before visiting.",
      icon: "ri-mail-line",
    },
    {
      id: "kalispell-4",
      name: "Flathead County Clerk of Court",
      type: "County Clerk Passport Acceptance",
      address: "920 S Main St, Suite 300",
      city: "Kalispell",
      state: "MT",
      zip: "59901",
      phone: "(406) 758-5870",
      hours: "Mon–Fri 8:00 AM – 4:30 PM",
      distance: "Downtown Kalispell — Flathead County Justice Center",
      website: "https://flathead.mt.gov/clerkofcourt/",
      websiteLabel: "Flathead County Clerk",
      notes: "Alternative to post office acceptance facilities. Appointment recommended. Does not offer photo services — bring your own passport photo.",
      icon: "ri-government-line",
    },
    {
      id: "kalispell-5",
      name: "Polson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "105 4th Ave E",
      city: "Polson",
      state: "MT",
      zip: "59860",
      phone: "(406) 883-2747",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Polson, Lake County — about 50 miles south of Kalispell",
      website: "https://tools.usps.com/find-location.htm?location=1387662",
      websiteLabel: "USPS Location",
      notes: "Serves Polson and Flathead Lake southern shore communities. Call ahead to confirm passport acceptance availability.",
      icon: "ri-mail-line",
    },
    {
      id: "kalispell-6",
      name: "Missoula Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1100 W Kent Ave",
      city: "Missoula",
      state: "MT",
      zip: "59801",
      phone: "(406) 549-3161",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Missoula — about 115 miles south of Kalispell",
      website: "https://tools.usps.com/find-location.htm?location=1377267",
      websiteLabel: "USPS Location",
      notes: "Largest USPS facility in western Montana with regular passport acceptance hours. About 2 hours drive from Kalispell — useful when local facilities are fully booked.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver Passport Agency, 760 miles and 12+ hour drive from Kalispell", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Aurora, CO near Denver; completely impractical for Flathead residents", fpc: "Most Kalispell travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — must prove travel date and emergency", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay, even more problematic from Montana", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Kalispell", agency: "760-mile drive to Denver one way — completely impractical for most Montana residents", fpc: "Entirely remote — forms online, ship from Kalispell, passport arrives at your door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof of travel", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but factoring in travel to Denver, time off work, and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Flathead Valley Context", agency: "No Flathead-specific guidance — no Glacier, FCA, or rural Montana expertise", fpc: "Full Flathead Valley/knowledge — Glacier, FCA airport, seasonal residency patterns" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming Glacier Trip Doesn't Need Passport",
      description: "Kalispell visitors and residents heading into Waterton Lakes National Park (Canada side of Glacier) need a passport for border crossing. Many assume a driver's license is sufficient — it is not for adults. We help Flathead families get passports before their Glacier adventures.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for FCA Connection Timing",
      description: "FCA connects through hubs like Seattle, Denver, and Minneapolis before international flights. A passport issue at the connection point delays the entire itinerary. We ensure your passport is valid at your first departure point.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Seasonal Residence Documentation Confusion",
      description: "Flathead Valley part-time residents often have old addresses on documents. Mismatched addresses cause delays. We review all documentation before submission to catch this common issue.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Some local Montana pharmacies produce photos that don't meet State Department standards. We catch this in review before it causes a rejection and delays your Glacier trip or cruise departure.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Waiting Too Long — Then Denver Is Not an Option",
      description: "Many Kalispell travelers wait until 2 weeks before departure, then realize Denver is 760 miles away. Our courier channel is the only practical expedited option in northwest Montana — but starting 2-4 weeks ahead is still recommended.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order from your Kalispell home or Whitefish office." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist — whether you are a seasonal Bigfork resident or a Whitefish family planning a Banff trip." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Kalispell clients ship from the UPS Store on Main Street — no Denver trip needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our processing center. We submit through reserved agency slots — so Flathead Valley travelers never need to drive to Denver." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is completed within your selected timeframe and shipped directly to your Kalispell, Whitefish, or Bigfork address. No agency visit. No Denver. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Kalispell, Montana?", a: "We offer Kalispell-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. Because Kalispell's nearest regional passport agency is in Denver (760 miles away), our remote courier service is the most practical fast option in northwest Montana." },
    { q: "Do I need to visit a Kalispell office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Kalispell post office, Whitefish post office, or Flathead County Clerk), then ship documents overnight. We handle the State Department submission and return your passport to your Flathead Valley address." },
    { q: "Where can I get a passport acceptance near Kalispell?", a: "Kalispell has acceptance facilities at the Main Post Office on Meridian Road, Flathead County Clerk of Court, and nearby USPS locations in Whitefish, Columbia Falls, and Polson. We maintain an updated list of Flathead-area facilities with hours and appointment requirements." },
    { q: "Do I need a passport to go from Glacier to Waterton in Canada?", a: "Yes. Waterton Lakes National Park is across the international border in Alberta, Canada. U.S. citizens need a valid passport for this border crossing — even for day trips across the Waterton-Glacier International Peace Park. A passport card also works for this land crossing." },
    { q: "What if I need a passport and Denver is too far?", a: "Denver Passport Agency is 760 miles from Kalispell — a 12+ hour drive each way. That's why our registered courier service is the best expedited option in northwest Montana. We handle the agency submission remotely, so you never leave the Flathead Valley." },
    { q: "What is the best price for expedited passport service in Kalispell?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "What documents do Kalispell applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Flathead-specific checklist." },
    { q: "Can I get a passport photo in Kalispell?", a: "Yes. Kalispell Main Post Office offers on-site passport photos. CVS, Walgreens, UPS Store, and Costco in Kalispell also provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How does seasonal residency affect passport applications in Flathead County?", a: "Part-time Flathead Valley residents should use their permanent residential address on passport applications. If your documents show different addresses, let us know — we guide you through the documentation to avoid delays caused by address mismatches." },
    { q: "Can you help with passports for FCA Glacier Park International Airport departures?", a: "Yes. FCA connects through major hubs like Seattle, Denver, and Minneapolis for international flights. We help Kalispell travelers time their passport processing around FCA connections, ensuring your passport is valid and ready before your first departure point." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Kalispell Residents",
    intro: "Kalispell's position in northwest Montana — surrounded by Glacier National Park and served by Glacier Park International Airport — creates unique passport timing challenges. Here's what Flathead Valley travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "FCA — Glacier Park International Airport",
        subtitle: "Kalispell's regional airport connecting to major hubs",
        description: "FCA serves the Flathead Valley with connections through Seattle, Salt Lake City, Denver, Minneapolis, and Chicago O'Hare. Most Kalispell international travelers connect through these hubs before flying overseas. The airport's seasonal schedule means summer months see a surge in passport urgencies as tourists, seasonal residents, and locals prepare for international connecting flights.",
        tip: "FCA connections to international flights mean your passport needs to be valid when you check in at Kalispell, not just at your international gateway. Check your passport the moment you book any international itinerary through FCA.",
      },
      {
        icon: "ri-road-map-line",
        title: "Glacier National Park — Cross-Border Travel",
        subtitle: "U.S.-Canada border access within the International Peace Park",
        description: "Glacier National Park and Waterton Lakes National Park in Alberta form the Waterton-Glacier International Peace Park. Many Kalispell-area residents and visitors cross between the two parks, requiring valid passports. The Chief Mountain border crossing east of the park is seasonal and closes in winter — creating concentrated summer demand for passport services.",
        tip: "Even a quick day trip to Waterton townsite requires a passport. Glacier visitors from across the U.S. often arrive in Kalispell without one. We process expedited passports so you do not miss your Canadian park experience.",
      },
      {
        icon: "ri-home-2-line",
        title: "Seasonal Residents & Snowbird Travel",
        subtitle: "Flathead Valley part-time residents with dual addresses",
        description: "The Flathead Valley has a large population of seasonal residents — people who spend summers in Kalispell, Bigfork, and Whitefish, then head to Arizona, Florida, or Mexico for the winter. These snowbirds often need passport renewals in the spring when returning to Montana, creating a predictable surge from March through May.",
        tip: "Seasonal residents should plan passport renewals before heading south in the fall. A passport renewal done in October means no rush when international spring travel plans surface the next year.",
      },
      {
        icon: "ri-compass-3-line",
        title: "Outdoor Adventure & International Guiding",
        subtitle: "Hunting, fishing, and outdoor guide travel to Canada and beyond",
        description: "Kalispell and Whitefish are hubs for outdoor professionals — hunting guides heading to British Columbia, fishing guides working Alaska seasons, and ski professionals traveling between hemispheres. These travelers need reliable fast passports with predictable turnaround times when seasonal work contracts surface with short notice.",
        tip: "Outdoor professionals working across borders should consider a second passport if their primary passport spends significant time with visa applications for international guiding seasons.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Kalispell & Cross-Border Canada Access",
      description: "Northwest Montana shares a long border with British Columbia and Alberta. Kalispell is the retail and service hub for Flathead Valley residents who regularly cross at the Roosville, Chief Mountain, and Wild Horse border crossings. Weekend trips to Fernie, Cranbrook, and Lethbridge are common — creating steady demand for passport cards and renewals among Flathead Valley families.",
    },
  },
  destinations: {
    title: "Where Kalispell Travelers Go — And Why Passports Get Urgent",
    intro: "Kalispell's unique location near the Canadian border and Glacier National Park shapes its international travel patterns. Here are the most common destinations and urgency scenarios we see.",
    stats: [
      { stat: "45%", label: "of Kalispell expedited requests involve Canada cross-border day trips or weekend travel" },
      { stat: "3–4 Weeks", label: "average lead time from trip booking to departure for Kalispell travelers" },
      { stat: "Mar–May", label: "peak season when seasonal residents return and summer travel bookings spike" },
      { stat: "760 Miles", label: "distance to nearest passport agency in Denver — our courier service bridges this gap" },
    ],
    destinations: [
      { name: "Canada", context: "Waterton Lakes National Park access, Fernie ski trips, Cranbrook shopping, Banff vacations, Calgary Stampede", urgency: "Summer peak demand when Glacier border crossings open fully", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Central America", context: "Flathead snowbirds wintering in Mexico, resort vacations, fishing expeditions to Baja", urgency: "Fall bookings as seasonal residents prepare for winter departure", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "Connections through Seattle and Denver, heritage travel to Ireland, UK, Germany, Scandinavian countries", urgency: "Summer vacation bookings made 4–6 weeks ahead", icon: "ri-map-pin-2-line" },
      { name: "New Zealand & Australia", context: "Outdoor guide seasonal work, ski professionals working Southern Hemisphere winter, adventure travel", urgency: "Seasonal contracts with 2–4 week turnaround from offer to departure", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Cruises", context: "Seattle and Vancouver cruise departures, all-inclusive resort vacations booked through travel agencies", urgency: "Last-minute cruise deals booked 2–3 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "Connections through Seattle and San Francisco, business travel for outdoor gear manufacturing partnerships", urgency: "Trade show and sourcing travel with fixed dates", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Montana Service Areas",
    crossLinksDesc: "We serve travelers across Big Sky Country with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Missoula", route: "/missoula" },
      { name: "Bozeman", route: "/bozeman" },
      { name: "Billings", route: "/billings" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Kalispell", address: "215 3rd Ave E, Kalispell, MT 59901", hours: "Daily 8 AM – 9 PM" },
    { name: "Walgreens — Kalispell", address: "25 Commons Way, Kalispell, MT 59901", hours: "Call for hours" },
    { name: "The UPS Store — Kalispell", address: "115 3rd St W, Kalispell, MT 59901", hours: "Call for hours" },
    { name: "Costco Wholesale — Kalispell", address: "2330 US-93 N, Kalispell, MT 59901", hours: "Call for photo center hours" },
    { name: "Walgreens — Whitefish", address: "6505 US-93 S, Whitefish, MT 59937", hours: "Call for hours" },
    { name: "FedEx Office — Missoula", address: "529 S Higgins Ave, Missoula, MT 59801", hours: "Call for hours (about 2 hours from Kalispell)" },
    { name: "Walmart Supercenter — Kalispell", address: "170 Hutton Ranch Rd, Kalispell, MT 59901", hours: "Daily 7 AM – 11 PM" },
  ],
  dmvLocations: [
    {
      name: "Flathead County Treasurer — Motor Vehicle Division",
      address: "290 N Main St, Kalispell, MT 59901",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Montana MVD — Kalispell Driver Exam Station",
      address: "2780 US-93 N, Kalispell, MT 59901",
      hours: "Tue–Fri, 7:30 AM – 5:00 PM (by appointment)",
      note: "Driver license testing and renewals. REAL ID available. Appointment required.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "FCA",
      name: "Glacier Park International Airport",
      distance: "About 8 miles north of downtown Kalispell",
      address: "4170 US-2, Kalispell, MT 59901",
      note: "Serves the Flathead Valley with connections to Seattle, Salt Lake City, Denver, Minneapolis, and Chicago O'Hare. Seasonal international charters. Gateway to Glacier National Park.",
      flightUrl: "https://www.iflyglacier.com/",
      flightLabel: "Glacier Park International Website",
      featured: true,
    },
    {
      code: "MSO",
      name: "Missoula Montana Airport",
      distance: "About 115 miles south of Kalispell (2 hours)",
      address: "5225 US-10 W, Missoula, MT 59808",
      note: "Larger regional airport with additional connections to Los Angeles, San Francisco, Las Vegas, and Phoenix. Alternative for Kalispell travelers needing more flight options.",
      flightUrl: "https://www.flymissoula.com/",
      flightLabel: "Missoula Airport Website",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified Montana birth certificates from the Montana Department of Public Health and Human Services. Online, mail, or in-person options available.",
      url: "https://dphhs.mt.gov/vitalrecords/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Montana DPHHS Vital Records. Required for estate and legal matters in Flathead County.",
      url: "https://dphhs.mt.gov/vitalrecords/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Flathead County Clerk of Court. Certified copies available for name changes and passport applications.",
      url: "https://flathead.mt.gov/clerkofcourt/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Flathead County District Court. Required for name change passport corrections.",
      url: "https://flathead.mt.gov/clerkofcourt/",
    },
  ],
};